import { Divider } from 'antd'
import CantileverRow from 'components/CantileverRow'
import React from 'react'
import styled from 'styled-components'

const LeadingContentContainer = styled.span`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`

const StyledDivider = styled(Divider)`
  height: 1.075rem;
  margin-top: 0.1875rem;
`

const StyledTitle = styled.span`
  cursor: default;
`

const IconWrapper = styled.div<{ $iconBackgroundColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 4rem;
  height: 4rem;
  background-color: ${(props) => props.$iconBackgroundColor};
  margin-right: 0.75rem;
`

export const PageHeaderWithIcon: React.FC<{
  icon?: React.ReactNode
  title?: string
  titleContent?: React.ReactNode
  iconBackgroundColor?: string
  subtitle?: string
  trailingContent?: React.ReactNode
}> = ({
  icon,
  title,
  titleContent,
  subtitle,
  iconBackgroundColor = 'transparent',
  trailingContent,
}) => (
  <CantileverRow
    pageTitle
    leadingContent={
      <LeadingContentContainer>
        {icon && (
          <IconWrapper $iconBackgroundColor={iconBackgroundColor}>
            {icon}
          </IconWrapper>
        )}

        {titleContent ? (
          <>{titleContent}</>
        ) : (
          <StyledTitle>{title}</StyledTitle>
        )}
        {subtitle && (
          <>
            <StyledDivider orientation='vertical' />
            <StyledTitle>{subtitle}</StyledTitle>
          </>
        )}
      </LeadingContentContainer>
    }
    trailingContent={trailingContent}
  />
)
